
const styles = () => ({
  depotDiscountInput: {
    marginBottom: 0,
    height: 30,
    background: '#fff',
  },
});

export default styles;